const baseStyle = {
  width: 'auto',
  height: 'auto',
};

export default {
  baseStyle,
};
